'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _reactHelmet = require('react-helmet');var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);

var _containers = require('../../containers');
var _components = require('../../components');

var _constants = require('../../constants');
var _multiLanguageHeadTags = require('../../helpers/multiLanguageHeadTags');var _multiLanguageHeadTags2 = _interopRequireDefault(_multiLanguageHeadTags);
var _formatPhoneNumber = require('../../utils/formatPhoneNumber');
var _WhatsAppWidget = require('../../components/WhatsAppWidget/WhatsAppWidget');var _WhatsAppWidget2 = _interopRequireDefault(_WhatsAppWidget);

var _ContactUsPage = require('./ContactUsPage.scss');var styles = _interopRequireWildcard(_ContactUsPage);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Helpers
// Styles
var ContactUsPage = function (_Component) {_inherits(ContactUsPage, _Component);function ContactUsPage() {var _temp, _this, _ret;_classCallCheck(this, ContactUsPage);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.renderContactPhone = function () {return _react2.default.createElement('a', { className: styles.contactItem, href: 'tel:' + (0, _formatPhoneNumber.authenticationFormatPhoneNumber)(_constants.ourContacts.phone), 'data-rel': 'external' },
        _react2.default.createElement('span', { className: 'icon icon-contacts-phone' }),
        _react2.default.createElement('span', null, _constants.ourContacts.phone));}, _temp), _possibleConstructorReturn(_this, _ret);}ContactUsPage.prototype.



  render = function render() {var _cx;var _props =
    this.props,route = _props.route,location = _props.location,locale = _props.locale,isNative = _props.isNative;
    var multiLanguage = (0, _multiLanguageHeadTags2.default)(route, locale);

    return (
      _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.contactPage, 'pageHeight', (_cx = {}, _cx[styles.native] = isNative, _cx)) },
        _react2.default.createElement(_reactHelmet2.default, {
          titleTemplate: this.props.translate('title', 'titleTemplate')(),
          title: this.props.translate('title', 'contact')(),
          meta: [{
            property: 'og:title',
            content: 'OnMap | ' + this.props.translate('footer', 'contactUs') }],

          link: [].concat(
          multiLanguage, [
          { rel: 'canonical', href: '' + _constants.shareUrl + route }]) }),


        _react2.default.createElement('div', { className: styles.content },

          !isNative &&
          _react2.default.createElement(_components.OMTitle, { className: 'pageTitle', title: this.props.translate('contactUsPage', 'title') }),


          _react2.default.createElement(_containers.ContactUsFormContainer, { isNative: isNative }),
          _react2.default.createElement('div', { className: styles.ourContacts },
            this.renderContactPhone(),
            _react2.default.createElement('div', { className: styles.contactItem },
              _react2.default.createElement('span', { className: 'icon icon-contacts-address' }),
              _react2.default.createElement('span', null, (0, _get2.default)(_constants.ourContacts, 'address[' + this.props.locale + ']'))))),



        _react2.default.createElement(_WhatsAppWidget2.default, { translate: this.props.translate })));


  };return ContactUsPage;}(_react.Component);


ContactUsPage.propTypes = {
  translate: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  route: _propTypes2.default.string.isRequired,
  location: _propTypes2.default.object,
  isNative: _propTypes2.default.bool,
  locale: _propTypes2.default.string };


var mapStateToProps = function mapStateToProps(state) {return {
    translate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    isNative: state.native.isNative };};exports.default =


(0, _reactRedux.connect)(mapStateToProps)(
ContactUsPage);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/ContactUsPage/ContactUsPage.js
// module id = 3082
// module chunks = 0